import "./StarMark.css";

/** Estrela de oito pontas do logotipo, extraída de `cosanova-logo.svg`. */
const STAR_PATH =
	"M74.0016 47.9586L54.5782 55.143C54.4235 55.2003 54.3519 55.3789 54.4235 55.5269L63.6511 74.5951C63.7676 74.8347 63.5156 75.0858 63.2769 74.9684L44.7004 65.8887C44.5343 65.8085 44.3376 65.9069 44.3023 66.0873L37.7728 99.7736C37.7145 100.073 37.2858 100.076 37.2238 99.7774L30.2646 66.2515C30.2274 66.0701 30.0269 65.9747 29.8627 66.0596L11.4876 75.5584C11.2509 75.6806 10.994 75.4352 11.1048 75.1937L19.9228 55.9202C19.9916 55.7703 19.9161 55.5937 19.7596 55.5393L0.189182 48.0607C-0.060007 47.9748 -0.0638295 47.6244 0.182495 47.5337L19.6059 41.0892C19.7605 41.0319 19.8321 40.8534 19.7605 40.7044L10.5329 21.6362C10.4174 21.3975 10.6685 21.1464 10.9072 21.2629L29.4922 30.3464C29.6545 30.4266 29.8493 30.3321 29.8885 30.1545L37.2305 0.220316C37.2944 -0.0708816 37.7088 -0.0746985 37.7766 0.216499L43.9127 29.9912C43.9538 30.1688 44.1514 30.2605 44.3137 30.1764L62.6964 20.6729C62.9332 20.5507 63.19 20.7961 63.0802 21.0376L54.2612 40.3111C54.1925 40.4619 54.2689 40.6385 54.4245 40.692L73.9958 47.4316C74.2441 47.5175 74.2479 47.8669 74.0016 47.9586Z";

type StarMarkProps = {
	/** Letra vazada no centro da estrela; sem ela, a estrela fica cheia. */
	letter?: string;
	className?: string;
};

/**
 * A estrela pinta-se com `currentColor`; a letra usa `--star-letter`, para o
 * mesmo componente servir tanto em fundo claro quanto escuro.
 */
export function StarMark({ letter, className }: StarMarkProps) {
	return (
		<svg
			className={["star-mark", className].filter(Boolean).join(" ")}
			viewBox="0 0 74.2 100"
			aria-hidden="true"
			focusable="false"
		>
			<path className="star-mark__shape" d={STAR_PATH} />
			{letter ? (
				<text
					className="star-mark__letter"
					x="37.1"
					y="49"
					textAnchor="middle"
					dominantBaseline="central"
				>
					{letter}
				</text>
			) : null}
		</svg>
	);
}
